const ContactPhone = ({
  width = 61,
  height = 61,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 61 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1185_45881)">
        <g clipPath="url(#clip1_1185_45881)">
          <g clipPath="url(#clip2_1185_45881)">
            <mask
              id="mask0_1185_45881"
              //   style="mask-type:luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="61"
              height="61"
            >
              <path
                d="M60.9766 0.28125H0.976562V60.2812H60.9766V0.28125Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_1185_45881)">
              <path
                d="M30.9766 60.2812C47.5451 60.2812 60.9766 46.8498 60.9766 30.2812C60.9766 13.7127 47.5451 0.28125 30.9766 0.28125C14.408 0.28125 0.976562 13.7127 0.976562 30.2812C0.976562 46.8498 14.408 60.2812 30.9766 60.2812Z"
                fill="#DDF3F6"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.385 30.8779C35.4239 35.9153 36.567 30.0876 39.7752 33.2936C42.8682 36.3857 44.6459 37.0052 40.7271 40.923C40.2362 41.3174 37.1175 46.0634 26.1571 35.106C15.1953 24.1473 19.9385 21.0253 20.3331 20.5346C24.2614 16.6061 24.8702 18.3941 27.9632 21.4862C31.1715 24.6936 25.3462 25.8405 30.385 30.8779Z"
                fill="#133345"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1185_45881">
          <rect
            width="60"
            height="60"
            fill="white"
            transform="translate(0.976562 0.28125)"
          />
        </clipPath>
        <clipPath id="clip1_1185_45881">
          <rect
            width="60"
            height="60"
            fill="white"
            transform="translate(0.976562 0.28125)"
          />
        </clipPath>
        <clipPath id="clip2_1185_45881">
          <rect
            width="60"
            height="60"
            fill="white"
            transform="translate(0.976562 0.28125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ContactPhone;
